import React from 'react';
import { useTranslation } from '@lt/localization';
import { Link } from '@lt/components';
import HotelRating from 'src/components/HotelRating';
import NotEnoughReviews from 'src/components/Reviews/components/NotEnoughReviews';
import HotelRelink from '../../../HotelRelink';
import ReviewsList from '../ReviewsList';
import Paper from '../../../Paper';

import styles from '../../reviews.module.css';

const ReviewsDesktop = ({
  isRatingExists,
  linkedHotels,
  searchParams,
  isWhitelabel,
  hasReviewsSection,
  hotelReviewsLink,
}) => {
  const showLinkedHotels = !isWhitelabel && linkedHotels.length > 0;
  const { t } = useTranslation();

  return (
    <div className={styles.ltHotelReviews}>
      {hasReviewsSection && !isWhitelabel ? (
        <div className="like-h2">
          <Link href={hotelReviewsLink} className={styles.linkTitle}>
            {t('hotel.reviews.title')}
          </Link>
        </div>
      ) : (
        <div className={styles.linkTitle}>{t('hotel.reviews.title')}</div>
      )}
      {hasReviewsSection ? (
        <div className={styles.ltHotelReviewsRow}>
          <div className={styles.ltHotelReviewsList}>
            <div className="lt-hotel-reviews-items">
              <ReviewsList />
            </div>
          </div>
          {(isRatingExists || showLinkedHotels) && (
            <div className={styles.rating}>
              <HotelRating />
              {showLinkedHotels && (
                <Paper>
                  <div className={styles.heading}>
                    {t('hotel.similarHotels')}
                  </div>
                  <HotelRelink
                    hotels={linkedHotels}
                    searchParams={searchParams}
                  />
                </Paper>
              )}
            </div>
          )}
        </div>
      ) : (
        <NotEnoughReviews isEmptyReviews />
      )}
    </div>
  );
};

export default ReviewsDesktop;
